<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon v-text="$route.icon"></v-icon>
            {{ $route.name }}
          </v-card-title>
          <v-card-subtitle align="left">
            {{ community.name }} ({{ community.code }})
          </v-card-subtitle>
          <v-card-text align="left">
            <div><strong> Community Plan: </strong> {{ community.plan }}</div>
            <div><strong> Members: </strong> {{ community.members }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="text-left">
          <v-btn fab color="primary" @click="dialog = true" top right absolute>
            <v-icon>add</v-icon>
          </v-btn>
          <v-card-title>Households ({{ households.length }})</v-card-title>
          <v-list two-line>
            <v-list-item v-for="household in households" :key="household.id">
              <v-list-item-avatar>
                <v-icon color="primary">home</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="household.name"></v-list-item-title>
                <v-list-item-subtitle
                  v-text="household.aptNumber + ' ' + household.streetName"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon>
                      <v-icon small color="grey lighten-1"
                        >fas fa-ellipsis-v</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="openMembers(household.id, household.name)"
                    >
                      <v-list-item-title>See Members</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="750px">
      <div class="text-right">
        <v-btn color="white" text @click="dialog = false">CLOSE</v-btn>
      </div>
      <AddHousehold :communityKey="this.community.id" />
    </v-dialog>
    <v-dialog v-model="membersDialog" max-width="750px">
      <div class="text-right">
        <v-btn color="white" text @click="membersDialog = false">CLOSE</v-btn>
      </div>
      <MembersList
        :household="currentHouseholdId"
        :householdname="currentHouseholdName"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import { communitiesRef, householdsRef } from "../../firebaseApp";
import AddHousehold from "../admin/AddHousehold.vue";
import MembersList from "../admin/MembersList";
import plansOptions from "../json/plans.json";

export default {
  data: () => ({
    community: {},
    dialog: false,
    membersDialog: false,
    plans: plansOptions,
    households: [],
    currentHouseholdId: "",
    currentHouseholdName: "",
  }),
  components: { AddHousehold, MembersList },
  computed: {
    cityStateZip: function () {
      return (
        this.community.city +
        ", " +
        this.community.state +
        " " +
        this.community.zipcode
      );
    },
    planColor: function () {
      if (this.community.plan) return this.plans[this.community.plan]["color"];
      else return "accent";
    },
  },
  methods: {
    openMembers(householdKey, householdName) {
      this.currentHouseholdId = householdKey;
      this.currentHouseholdName = householdName;
      this.membersDialog = true;
    },
    loadHouseholds() {
      let communityId = this.community.id;
      householdsRef.on("value", (snap) => {
        let households = [];
        snap.forEach((household) => {
          if (household.val().communityKey == communityId) {
            let home = {};
            home = household.val();
            home.id = household.key;
            households.push(home);
          }
        });
        this.households = households;
      });
    },
  },
  mounted() {
    let communityId = this.$route.params.id;
    communitiesRef.on("value", (snap) => {
      snap.forEach((community) => {
        if (
          community.key == communityId ||
          community.val().code == communityId
        ) {
          let comm = {};
          comm = community.val();
          comm.id = community.key;
          this.community = comm;
          this.loadHouseholds();
        }
      });
    });
  },
};
</script>